<app-vetai-header
  [config]="menu"
  [showSubMenu]="false"
  [setWhitebackground]="false"
  [sourceProject]="'PMS'"
  [ngClass]="{ dark: darkModeService.darkModeOn() }"
  [attr.data-theme]="darkModeService.darkModeOn() ? 'dark' : 'light'"
>
  <router-outlet></router-outlet>
</app-vetai-header>
<app-staffonlinewrite></app-staffonlinewrite>
